<div class="chips">
    @for (chipData of chipDataList;track chipData) {
        <upsc-dw-rewardship-advanced-filter-chip [data]="chipData"
                                                 (parameterRemoved)="onParameterRemoved($event)"></upsc-dw-rewardship-advanced-filter-chip>
    }
</div>
